module.exports = __webpack_public_path__ + "static/media/edit.69563e0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/edit.svg
// module id = 36
// module chunks = 0